<template>
  <div>
    <!-- Main arrival/departure (day view) — single leg -->
    <v-row v-if="flight.basic" class="px-1 caption flight-detail-row" dense no-gutters>
      <v-col class="py-0 flight-leg-label d-flex align-center">
        <v-icon small class="mr-1">flight</v-icon>
      </v-col>
      <v-col class="py-0">
        <div class="flight-fields">
          <div class="flight-field">
            <a-field :config="config.date" disabled :value="flight.date || ''" />
          </div>
          <div class="flight-field">
            <a-field :config="config.airport" disabled :value="flight.airport || ''" />
          </div>
          <div class="flight-field">
            <a-field :config="config.flight_num" disabled :value="flight.flight_num || ''" />
          </div>
          <div class="flight-field">
            <a-field :config="config.time" disabled :value="flight.time || ''" />
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Secondary domestic/international — same grid as main flight -->
    <template v-else>
      <v-row v-if="showArrival" class="px-1 caption flight-detail-row" dense no-gutters>
        <v-col class="py-0 flight-leg-label" align-self="center">Arrival</v-col>
        <v-col class="py-0">
          <div class="flight-fields">
            <div class="flight-field">
              <a-field :config="config.date" disabled :value="arriveDate || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.airport" disabled :value="flight.arrive_airport || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.flight_num" disabled :value="arriveFlightNum || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.time" disabled :value="flight.arrive_time || ''" />
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="showDeparture" class="px-1 caption flight-detail-row" dense no-gutters>
        <v-col class="py-0 flight-leg-label" align-self="center">Departure</v-col>
        <v-col class="py-0">
          <div class="flight-fields">
            <div class="flight-field">
              <a-field :config="config.date" disabled :value="departDate || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.airport" disabled :value="flight.depart_airport || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.flight_num" disabled :value="departFlightNum || ''" />
            </div>
            <div class="flight-field">
              <a-field :config="config.time" disabled :value="flight.depart_time || ''" />
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { BookingFields } from "@/config/fields/bookings";
import {
  hasArrival,
  hasDeparture,
  arrivalDate,
  departureDate,
  arrivalFlightNum,
  departureFlightNum,
} from "../flightUtils";

export default {
  props: {
    flight: Object,
  },
  data() {
    return {
      config: BookingFields.flight,
    };
  },
  computed: {
    showArrival() {
      return hasArrival(this.flight);
    },
    showDeparture() {
      return hasDeparture(this.flight);
    },
    arriveDate() {
      return arrivalDate(this.flight);
    },
    departDate() {
      return departureDate(this.flight);
    },
    arriveFlightNum() {
      return arrivalFlightNum(this.flight);
    },
    departFlightNum() {
      return departureFlightNum(this.flight);
    },
  },
};
</script>
